import React from 'react';

const Paperclip = ({ width = 16, height = 16, color = '#9f9ea3' }) => (
  <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
    <title>paperclip</title>
    <g fill={color}>
      <path fill={color} d="M9.6,12.8c-1.6,1.6-4.1,1.6-5.7,0c-1.6-1.6-1.7-4-0.1-5.5l4.5-4.5c1-1,2.6-1,3.5,0c1,1,1,2.6,0,3.5L8.3,9.9 c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l2.8-2.8L8.2,4.3L5.5,7c-1.2,1.2-1.2,3.1,0,4.2s3.1,1.2,4.2,0l3.6-3.6 c1.8-1.8,1.8-4.6,0-6.4c-1.8-1.8-4.6-1.8-6.4,0L2.4,5.9c-2.3,2.3-2.2,6,0.1,8.3C3.7,15.4,5.2,16,6.8,16s3.1-0.6,4.2-1.8l4.3-4.3 l-1.4-1.4L9.6,12.8z" />
    </g>
  </svg>
);

export default Paperclip;